<template>
  <!-- fade duration时间同子元素modal__xml-box transition 时间-->
 <transition name="fade" :duration="300">
   <div v-if="show" class="modal-goods-list" ref="goodsList" >
    <!--5.0电商商品/订单列表 底部按钮点击弹出 -->
    <div v-show="!errorShow" class="modal" @click.stop="()=>{}">
      <div ref="modalCt" class="modal__xml-box" >
        <div class="xml__header">
          <div class="xml__title">
            <div class="xml__text">请选择您要咨询的商品</div>
            <div class="xml__close" @click.stop="hide">
              <img class="icon-arrow-down" src="./assets/arrow-down.svg" />
            </div>
          </div>
          <div class="xml__tabs">
             <div  v-for="tab in ecQuickMenu.goodsTab" :key="tab.key"
              :class="['tabs__item',params.tab === tab.key ? 'tabs__item--active' : '' ]"
               >
                <div class="tabs__item__name" @click="changeTab(tab)">
                  {{tab.name}}
                </div>
              </div>
          </div>
        </div>
        <div class="xml__body">
           <div v-for="g in listData" :key="g.id"  @click="sendMsg(g)" class="im-product-list-item xml__item" >
                  <div class="list-item-left">
                    <img class="item-cover" :src="g.image" />
                  </div>
                  <div class="list-item-right">
                    <div class="item-name">{{g.title}}</div>
                    <div class="item-tag">
                        <span v-if="g.inventoryCustom">{{g.inventoryCustom}}</span>
                        <span v-else-if="g.inventory !== null">库存:{{g.inventory}}</span>
                    </div>
                    <div class="item-tag">
                        <span v-if="g.salesCustom" >{{g.salesCustom}}</span>
                        <span v-else-if="g.sales !== null" >销量:{{g.sales}}</span>
                    </div>
                    <div class="item-price">
                      {{g.currencyUnit}}{{g.price}}
                    </div>
                  </div>
           </div>
           <div v-if="listData.length === 0" class="im-ecommerce-empty-list">
                <div class="im-ecommerce-empty-list-inner">
                    <img class="empty-list-img" src="./assets/ecommerce-empty-list.svg"/>
                    <p class="empty-list-text">暂无商品</p>
                </div>
            </div>
        </div>
        <div v-show="hasNextPage" @click.stop="nextPage" class="xml__footer">
          点击加载更多
          <img v-show="loading"  class="icon-more anim-rotate" src="@/components-aio/pc/assets/loading.svg" />
        </div>
      </div>
    </div>
    <!--电商错误提示 -->
    <div v-show="errorShow" class="toast-goods--error" >{{errorMessage || '该功能不可用'}}</div>
  </div>
 </transition>
</template>

<script>
// import StringUtils from '@/utils/string';
// import { IMSDK } from '@/imsdk/index.ts';
// import qs from 'qs';
import { EC_SENCE, getGoodsOrderList } from '@/components-business/EcGoodsOrder/ECGoodsOderApi.js';

// const imsdk = IMSDK.create();
/**
 * @component 电商商品列表显示
 * @author mingmlei
 */
export default {
  mixins: [],
  inject: ['globalData', 'to', 'MsgType', 'IMSDKType'],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // 电商5.0配置
    ecQuickMenu: {
      type: Object,
      default: () => ({
        goodsTab: [],
        orderTab: [],
      }),
    },
    // wpaDetail 的数据
    wpaDetail: {
      type: Object,
      default: () => ({
      }),
    },
  },
  components: {

  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
    // 是否能分页
    hasNextPage() {
      if (this.listData.length >= this.total) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      show: this.value,
      loading: false, // 是否在加载数据
      errorShow: false, // 错误显示
      errorMessage: '', // 错误提示信息
      total: 0, // 总记录数
      listData: [], // 商品列表,
      params: {
        scene: 1, // 商品场景
        // secretKey: this.globalData.thirdAppConfig.secretKey,
        // robotId: this.globalData.reception.extuin,
        robotId: this.globalData.reception.extuin,
        // webim 固定为4，由于webim sdk并没有开放方法出来获取通路类型，所以这里先写死
        channelType: 4,
        tab: '',
        page: 1,
        pageSize: 10,
      }, // 初始参数
    };
  },
  watch: {
    value() {
      this.show = this.value;
    },
    show(newVal) {
      this.$emit('input', this.show);
      if (newVal) {
        // 如果没有选择过tab，将其设置为第一个tab
        if (this.selectTab === '' && this.ecQuickMenu.goodsTab.length > 0) {
          this.selectTab = this.ecQuickMenu.goodsTab[0].key;
        }
        // 有选择的tab值
        if (this.selectTab !== '') {
          this.reset();
          this.getList();
        }

        document.addEventListener('click', this.hide);
      } else {
        document.removeEventListener('click', this.hide);
      }
      // this.$nextTick(() => {
      //   console.log('content-ct', this.$refs.modalCt);
      //   window.setTimeout(() => {
      //     this.sliderUp = this.show;
      //   }, 100);
      // });
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestory() {
    document.removeEventListener('click', this.hide);
  },

  methods: {
    reset() {
      this.errorShow = false;
      this.params.tab = this.ecQuickMenu.goodsTab.length > 0 ? this.ecQuickMenu.goodsTab[0].key : '';
      this.params.page = 1;
      this.listData = [];
    },
    getList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      getGoodsOrderList(this.params).then((res) => {
        if (res.code === 0) {
          this.total = res.total;
          this.listData = this.listData.concat(res.data);
        } else {
          this.errorShow = true;
          this.errorMessage = res.message;
        }


        this.loading = false;
      })
        .catch((error) => {
          console.log('error', error);
          this.errorMessage = '';
          this.errorShow = true;
          this.loading = false;
        });
    },
    nextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.params.page = this.params.page + 1;
      this.getList();
    },
    changeTab(tab) {
      // tab没有变就不查询
      if (tab.key === this.params.tab) {
        return;
      }
      this.reset();
      this.params.tab = tab.key;
      this.getList();
    },
    sendMsg(item) {
      this.hide();
      // 后台要求 extRobotType 电商的固定写4
      this.$parent.sendQDXMLMessage(
        {
          qdxml: {
            content: item.xmlMsg,
            brief: '零售电商卡片消息',
          },
        },
        null,
        {
          robot_ctrl: {
            str_ext2robot: JSON.stringify({ scene: EC_SENCE.goods, extRobotType: 4 }),
          },
        },
      );
    },
    // eslint-disable-next-line no-unused-vars
    hide(event) {
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-goods-list {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99;
  /deep/
  .modal__xml-box {
    position: absolute;
    bottom: 0;
    max-height: 465px;
    height: auto;
    min-height: 200px;
    width: 100%;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    font-family: PingFang SC;
    font-style: normal;
    color: #262d3d;
    // transform: translateY(100%);
    // transition: transform 10s;
    &.slider-up{
       transform: translateY(0);
    }
    div {
      box-sizing: border-box;
    }
    .xml__header {
      .xml__title {
        position: relative;
        display: flex;
        justify-content: center;
        height: 48px;
        line-height: 48px;
        .xml__text {
          font-size: 16px;
          font-weight: 500;
        }
        .xml__close {
          position: absolute;
          right: 16px;
          cursor: pointer;
          .icon-arrow-down {
            width: 24px;
            height: 24px;
          }
        }
      }
      .xml__tabs {
        display: flex;
        overflow-x: auto;
        min-width: 100%;
        border-bottom: 1px solid #f0f0f0;
        .tabs__item {
          flex-grow: 1;
          flex-shrink: 0;
          padding: 10px 6px 0px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          .tabs__item__name{
            padding-bottom: 12px;
          }
          &.tabs__item--active {
            .tabs__item__name{
              color: #4a70ff;
              font-weight: 500;
              padding-bottom: 10px;
              border-bottom: 2px solid #337eff;
            }
          }
        }
      }
    }
    .xml__body {
            max-height: 345px;
            overflow-y: auto;
            .im-product-list-item {
                cursor: pointer;
                padding: 8px 0;
                margin: 0 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px dashed rgba(18, 42, 79, 0.08);
                .list-item-left {
                flex: 0;
                align-self: flex-start;
                .item-cover {
                    display: block;
                    width: 60px;
                    height: 60px;
                }
                }
                .list-item-right {
                    margin-left: 8px;
                    flex: auto;
                    font-family: 'PingFang SC';
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    min-height: 60px;
                    .item-name {
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        color: rgba(0, 1, 10, 0.93);
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .item-price {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 20px;
                        color: #F75559;
                        white-space: break-spaces;
                        word-break: break-all;
                        margin-top: 2px;
                    }
                    .item-tag {
                        margin-top: 2px;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 16px;
                        color: #979BAA;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                    }
                }
            }
            .im-order-wrapper {
                cursor: pointer;
                margin: 0 12px;
                padding: 16px 0 8px;
                border-bottom: 1px dashed rgba(18, 42, 79, 0.08);
                .im-order-head {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .shop-info {
                    display: flex;
                    align-items: center;
                    max-width: calc(100% - 50px);
                    .shop-icon {
                      width: 16px;
                      height: 16px;
                      margin-right: 4px;
                      flex: none;
                    }
                    .shop-name {
                      font-family: 'PingFang SC';
                      font-style: normal;
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 20px;
                      color: rgba(3, 10, 38, 0.65);
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                  }
                  .order-status {
                    font-family: 'PingFang SC';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    color: rgba(0, 1, 10, 0.93);
                    flex: none;
                  }
                }
                .im-order-content {
                  margin-top: 8px;
                  display: flex;
                  align-items: flex-start;
                  .list-item-left {
                    .item-cover {
                      width: 60px;
                      height: 60px;
                    }
                  }
                  .list-item-right {
                    margin-left: 8px;
                    flex: auto;
                    .order-name {
                      font-family: 'PingFang SC';
                      font-style: normal;
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 20px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .order-detail {
                      margin-top: 2px;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      width: 420px;
                      .order-desc {
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 16px;
                        color: rgba(3, 10, 38, 0.65);
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      }
                      .order-count {
                        flex: none;
                        margin-left: 8px;
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 16px;
                        color: rgba(1, 11, 50, 0.41);
                      }
                    }
                  }
                }
                .im-oredr-footer {
                  margin-top: 8px;
                  .item-desc {
                    margin-top: 2px;
                    display: flex;
                    align-items: center;
                    font-family: 'PingFang SC';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    text-align: right;
                    color: rgba(1, 11, 50, 0.41);
                    word-break: break-all;
                    &-label {
                        flex-shrink: 0;
                    }
                    &-value {
                      text-align: left;
                      &.price {
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 16px;
                        color: #F75559;
                      }
                    }
                  }
                }
            }
            .im-ecommerce-empty-list {
                min-height: 345px;
                display: flex;
                align-items: center;
                justify-content: center;
                .im-ecommerce-empty-list-inner {
                    .empty-list-text {
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: center;
                        color: rgba(1, 11, 50, 0.41);
                    }
                    .empty-list-img {
                        width: 100px;
                        height: 100px;
                    }
                }
            }
     }
    .xml__footer {
      width: 100%;
      line-height: 20px;
      font-size: 10px;
      text-align: center;
      .icon-more{
        width: 14px;
        height: 14px;
      }
    }
  }
  /deep/
  .toast-goods--error{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -13px;
    margin-left: -47px;
    padding: 4px 4px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #fff;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.44);
  }
  &.fade-enter{
    .modal__xml-box{
      // transform: translateY(100%);
      display: block;
    }
  }
  &.fade-enter-active{
    .modal__xml-box{
      transform: translateY(100%);
      transition: transform 0.3s;
    }
  }
   &.fade-enter-to{
       .modal__xml-box{
        transform: translateY(0);
      }
   }
   &.fade-leave{
    .modal__xml-box{
      display: block;
    }
  }
   &.fade-leave-active{
    .modal__xml-box{
      transform: translateY(0);
      transition: transform 0.3s;
    }
  }
   &.fade-leave-to{
       .modal__xml-box{
        transform: translateY(100%);
      }
   }
}
.h5-site {
  .modal-goods-list {
    .xml__tabs {
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
